import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getReportsStore from "../../../stores/reports-store";
import ReportsByType from "./reports-by-type";
import PendingReports from "./pending-reports";
import ET3Div from "../../../core/et3-div";
import Et3Text from "../../../core/et3-text";
import Et3Margin from "../../../core/et3-ui/ET3Margin";

const ReportsData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;

  const isVisible =
    getReportsStore().isDefinedReportsByTypeData.get() ||
    getReportsStore().isDefinedPendingReportsData.get();
  return isVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      width={1500}
      height={100}
      color={colors.all.white}
      style={{
        borderRadius: 45 * unitX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        withShadow={false}
        width={1500}
        height={100}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={20}
          text={i18n.get("REPORTS")}
          isSpan={false}
          color={colors.all.black}
          style={{
            width: 1440 * unitX,
            display: "flex",
            justifyContent: "flex-start"
          }}
        />
      </ET3Div>
      <PendingReports />
      <ReportsByType />
      <Et3Margin top={50} bottom={0} right={0} left={0} />
    </ET3Div>
  ) : null;
});
export default ReportsData;
